import {
  Button,
  IconButton,
  VStack,
} from '@chakra-ui/react';
import { BsFillFlagFill, BsPlusCircle } from 'react-icons/bs';
import React from 'react';
import { FaArrowRightLong } from 'react-icons/fa6';
import { CARD_TYPE, PRODUCT } from '@constants';
import GenericCard from '@components/GenericCard';
import { FaInfoCircle } from 'react-icons/fa';


const GomsOnHoldFulfillmentCard = ({
  fulfillmentData,
  selectedFulfillment,
  setSelectedFulfillment,
  onRecentTransfersClick,
  handleFlagClick,
  handleTagClick
}) => {

  const handleDetailClick = () => {
    setSelectedFulfillment(fulfillmentData);
    // Trigger recent transfers callback
    if (onRecentTransfersClick) {
      onRecentTransfersClick({
        userId: fulfillmentData.ownerId,
        orderId: fulfillmentData.orderId
      });
    }
  }
  return (
    <VStack
      alignSelf={'flex-start'}
      w={{ base: '100%', md: '100%' }}
      maxW={'full'}
      bg="backGround"
      borderRadius="12px"
      position="relative"
    >
      {fulfillmentData?.additionalDetails?.complianceData?.complianceFlagged ? (
        <IconButton
          position={'absolute'}
          rounded={'full'}
          top={-2}
          right={-2}
          bg={'altGray.500'}
          color={'red.500'}
          _hover={{
            background: 'red.500',
            color: 'altGray.500'
          }}
          size={'sm'}
          fontSize={'0.9rem'}
          fontWeight={400}
          icon={<BsFillFlagFill />}
          onClick={() => handleFlagClick(fulfillmentData)}
          zIndex={10}
        />
      ) : (
        <IconButton
          position={'absolute'}
          rounded={'full'}
          top={-2}
          right={-2}
          bg={'altGray.500'}
          color={'brand.200'}
          _hover={{
            background: 'brand.200',
            color: 'altGray.500'
          }}
          size={'sm'}
          fontSize={'0.9rem'}
          fontWeight={400}
          icon={<BsPlusCircle />}
          onClick={() => handleFlagClick(fulfillmentData)}
          zIndex={10}
        />
      )}
      {fulfillmentData?.tags && (
        <IconButton
          position={'absolute'}
          rounded={'full'}
          top={-2}
          left={-2}
          bg={'altGray.500'}
          color={'brand.200'}
          _hover={{
            background: 'red.500',
            color: 'altGray.500'
          }}
          size={'sm'}
          fontSize={'0.9rem'}
          fontWeight={400}
          icon={<FaInfoCircle />}
          onClick={handleTagClick}
          zIndex={10}
        />
      )}
      {fulfillmentData?.product === PRODUCT.REMITTANCE ? (
        <GenericCard
          cardData={fulfillmentData}
          cardType={CARD_TYPE.GOMS_FULFILLMENT_DASHBOARD.REMITTANCE_FULFILLMENT_CARD}
          maxW={'100%'}
          selected={fulfillmentData?.fulfillmentId === selectedFulfillment?.fulfillmentId}
          ActionButtons={[
            <Button
              key="details-button"
              colorScheme="brand"
              color="black"
              width="8rem"
              size="sm"
              fontSize="sm"
              mt={3}
              onClick={handleDetailClick}
              rightIcon={<FaArrowRightLong />}
            >
              Details
            </Button>
          ]}
        />
      ) : fulfillmentData?.product === PRODUCT.BBPS ? (
        <GenericCard
          cardData={fulfillmentData}
          cardType={CARD_TYPE.GOMS_FULFILLMENT_DASHBOARD.BBPS_FULFILLMENT_CARD}
          maxW={'100%'}
          selected={fulfillmentData?.fulfillmentId === selectedFulfillment?.fulfillmentId}
          ActionButtons={[
            <Button
              key="details-button"
              colorScheme="brand"
              color="black"
              width="8rem"
              size="sm"
              fontSize="sm"
              mt={3}
              onClick={handleDetailClick}
              rightIcon={<FaArrowRightLong />}
            >
              Details
            </Button>
          ]}
        />
      ) : null}
    </VStack>
  );
};

export default GomsOnHoldFulfillmentCard;